import React from 'react';
import { GenericTextArea } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from '../../../types';
import { isValidGlobalBehaviour } from '../../../utils/validation';
const MIN_CHARACTERS = 4;

const required = (value) =>
  isValidGlobalBehaviour(value && value.trim(), 'alphanumericSpaceBusinessActivities') &&
  (value.length > MIN_CHARACTERS || value.length === MIN_CHARACTERS)
    ? undefined
    : 'Required';
const textAreaLength = (values) =>
  values.activityTypes !== undefined ? values.activityTypes.length : 0;
const ActivityTypes = ({ formFieldValues, maxCharacters, isSubmitted, onChange }) => (
  <Content>
    {({ activityType, activityTypeError, activityTypeHelpText }) => (
      <Field name="activityTypes" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            name="activityTypes"
            title={activityType}
            validationMessage={(isSubmitted || touched) && !!error ? activityTypeError : ''}
            description={activityTypeHelpText}
          >
            <Field name="activityTypes" component="Textarea" validate={required}>
              {({ input }) => (
                <GenericTextArea
                  hideCharacterCount
                  maximumCharacters={maxCharacters}
                  id="activityTypes"
                  {...input}
                  maxLength={maxCharacters}
                  onChange={({ value }) => {
                    if (value && value.length > maxCharacters) return;
                    input.onChange(value);
                    onChange('activityTypes', value);
                  }}
                />
              )}
            </Field>

            <div className="c-m-form-field__footer c-a-field-helper">
              <p>Max: {maxCharacters - textAreaLength(formFieldValues)} characters</p>
            </div>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);
ActivityTypes.propTypes = {
  maxCharacters: PropTypes.number,
  formFieldValues: PropTypes.shape({})
};

ActivityTypes.defaultProps = {
  maxCharacters: 500,
  formFieldValues: {}
};

export default ActivityTypes;
